import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import {
//   // Card,
//   CardActionArea,
//   CardContent,
//   Typography,
//   // Button,
//   Box,
//   TextField,
//   // Select,
//   // MenuItem,
//   // Tabs,
//   // Tab,
//   Snackbar,
//   // Alert,
// } from "@mui/material";

// import SearchIcon from "@mui/icons-material/Search";
// import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
// import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";

import { colors, space, radius, borders } from "../design/tokens";

import {
  Screen,
  Content,
  Card,
  TextInput,
  Button,
  Text,
  Select,
  // Row, 
  Grid,
  Alert,
  Tabs,
  Tab,
  // CircularProgress,
  // Box
} from "./layout";

import {
  IconSearch,
  IconBooks,
  IconQrcode,
} from "@tabler/icons-react";

import { saveImageToIndexedDB } from "../storage/imageStorage";

import { selectAllFoods } from "../store/selectors";
import { addFood } from "../store/foodsSlice";
import FoodFormModal from "./forms/FoodFormModal";
import FoodImage from "./utils/FoodImage";
import OpenFoodFactsSearch from "./utils/USDAFoodSearch";
import BarcodeScanner from "./utils/BarcodeScanner";
import ScanResultCard from "./utils/ScanResultCard";
import { DeleteConfirmDialog } from "./utils/DeleteConfirmDialog";

import defaultImage from "../assets/images/default-image.jpg";
import { removeFood } from "../store/foodsSlice"; // ← confirm action name
import { IconTrash } from "@tabler/icons-react";

export default function FoodOverviewGrid({ onSelectFood }) {

  const foods    = useSelector(selectAllFoods);
  const dispatch = useDispatch();

  const [modalFood, setModalFood]     = useState(null);
  const [modalOpen, setModalOpen]     = useState(false);
  const [search, setSearch]           = useState("");
  const [category, setCategory]       = useState("all");
  const [tab, setTab]                 = useState(0); // 0 = My Library, 1 = Search, 2 = Scan
  const [scannedFood, setScannedFood] = useState(null); // food pending confirmation
  const [toast, setToast]             = useState(null);
  const [dupeFood, setDupeFood] = useState(null);
   const [pendingDeleteId, setPendingDeleteId] = useState(null);

  const isPickerMode = Boolean(onSelectFood);

  const filteredFoods = foods.filter((food) => {
    const text = search.toLowerCase();
    const matchSearch   = food.name.toLowerCase().includes(text);
    const matchCategory = category === "all" || food.categorie?.toLowerCase() === category;
    return matchSearch && matchCategory;
  });

  const handleClickFood = (food) => {
    if (isPickerMode) { onSelectFood(food); return; }
    setModalFood(food);
    setModalOpen(true);
  };

  const handleAddFood = () => {
    setModalFood(null);
    setModalOpen(true);
  };

  // Step 1: scanner found a product → show confirmation card, pause scanner
  const handleScanResult = (food) => {
    setScannedFood(food);
  };

  // Step 2a: user confirms → dispatch, toast, back to library
  // const handleConfirm = () => {
  //   dispatch(addFood(scannedFood));
  //   setToast(`"${scannedFood.name}" added to library`);
  //   setScannedFood(null);
  //   setTab(0);
  // };

  const handleConfirm = async () => {
  const food = { ...scannedFood };

  // Download OFF image and store in IndexedDB if available
  if (food.imageUrl) {
    try {
      const res = await fetch(food.imageUrl);
      const blob = await res.blob();
      const imageKey = `food_${food.id}`;
      await saveImageToIndexedDB(imageKey, blob);
      food.imageKey = imageKey;   // same field your FoodImage component reads
    } catch {
      // image download failed — continue without it
    }
    delete food.imageUrl; // don't store the remote URL, use imageKey instead
  }

  dispatch(addFood(food));
  setToast(`"${food.name}" added to library`);
  setScannedFood(null);
  setTab(0);
};

  // Step 2b: user discards → clear and restart scanner
  const handleDiscard = () => {
    setScannedFood(null);
  };

  return (
    <Screen>
      {/* Tabs — hide in picker mode */}
      {!isPickerMode && (
        // <Tabs
        //   value={tab}
        //   onChange={(_, v) => { setTab(v); setScannedFood(null); }}
        //   sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
        // >
        //   <Tab icon={<LibraryBooksIcon fontSize="small" />} iconPosition="start" label="My Library" />
        //   <Tab icon={<SearchIcon fontSize="small" />} iconPosition="start" label="Food Search" />
        //   <Tab icon={<QrCodeScannerIcon fontSize="small" />} iconPosition="start" label="Scan" />
        // </Tabs>
        <Tabs
          value={tab}
          onChange={(_, v) => {
            setTab(v);
            setScannedFood(null);
          }}
        >
          <Tab
            active={tab === 0}
            onClick={() => {
              setTab(0);
              setScannedFood(null);
            }}
            icon={<IconBooks size={10} />}
            label="My Library"
          />

          <Tab
            active={tab === 1}
            onClick={() => {
              setTab(1);
              setScannedFood(null);
            }}
            icon={<IconSearch size={10} />}
            label="Food Search"
          />

          <Tab
            active={tab === 2}
            onClick={() => {
              setTab(2);
              setScannedFood(null);
            }}
            icon={<IconQrcode size={10} />}
            label="Scan"
          />
        </Tabs>
      )}
      
      <Content>

      {/* ── Tab 0: My Library ── */}
      {tab === 0 && (
        <>
          <TextInput
            placeholder="Search food..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{marginBottom:space.md}}
          />
          <Select
            value={category}
            placeholder="All categories"
            options={[
              { label: "All categories", value: "all" },
              { label: "Meat", value: "meat" },
              { label: "Fish", value: "fish" },
              { label: "Dairy", value: "dairy" },
              { label: "Vegetable", value: "vegetable" },
              { label: "Fruits", value: "fruits" },
              { label: "Grain", value: "grain" },
              { label: "Side dish", value: "side dish" },
              { label: "Drink", value: "drink" },
              { label: "Sweet", value: "sweet" },
              { label: "Vegan", value: "vegan" },
              { label: "Other", value: "other" },
            ]}
            onChange={setCategory}
            style={{marginBottom:space.md}}
          />

          {!foods?.length ? (
            <>
            <Text >No foods yet</Text>
            <Button onClick={handleAddFood} style={{marginBottom:space.md, marginTop:space.lg}}>
              Add first food
            </Button>
            </>
          ) : (
            <>
              <Grid
                gap= "5px"
              >
                {filteredFoods.map((food) => (
                  <Card 
                    key={food.id}
                    onClick={() => handleClickFood(food)}
                    style={{
                      width:"100px",
                      padding:"0px !important",
                      position: "relative"
                      
                    }}
                  >
                      {/* IMAGE */}
                      {food.imageKey && (
                        <FoodImage imageKey={food.imageKey} alt={food.name} />
                      )}
                      {!food.imageKey && (<img src={defaultImage} alt="" width={100} height={100} style={{ objectFit: "cover" }} />)}



                      <Text 
                        style={{
                          fontWeight:"regular", 
                          fontSize:"10px",
                          lineHeight:"1"
                        }}
                      >
                        <span style={{fontWeight:"bold"}}> {food.name}</span> • {food.calories} kcal
                      
                        {/* {food.name} {food.calories} kcal • {food.protein}p • {food.carbs}c • {food.fat}f */}
                        
                      </Text>

                      <Text 
                        style={{
                          fontWeight:"regular", 
                          fontSize:"10px",
                          lineHeight:"1"
                        }}
                      >
                        
                      </Text>

                      {/* <Text 
                        style={{
                          fontWeight:"regular", 
                          fontSize:"10px",
                          lineHeight:"1"
                        }}
                      >
                        {food.categorie}
                      </Text> */}
                      <button
                        // onClick={(e) => {
                        //   e.stopPropagation(); // ← prevent card click / modal open
                        //   dispatch(removeFood(food.id));
                        // }}
                      onClick={(e) => {
                        e.stopPropagation();          // ← prevents card click
                          setPendingDeleteId(food.id);
                        }}
                        style={{
                          position: "absolute",
                          top: 4,
                          right: 4,
                          background: "rgba(0,0,0,0.4)",
                          border: "none",
                          borderRadius: "50%",
                          width: 24,
                          height: 24,
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 0,
                        }}
                      >
                        <IconTrash size={14} color="white" />
                      </button>

                      {pendingDeleteId === food.id && (
                        <DeleteConfirmDialog
                          entryName={food.name}
                          onConfirm={() => {
                            dispatch(removeFood(food.id));
                            setPendingDeleteId(null);
                          }}
                          onCancel={() => setPendingDeleteId(null)}
                        />
                      )}

                  </Card>
                ))}
              </Grid>

              {!isPickerMode && (
                <Button 
                onClick={handleAddFood}
                style={{marginBottom:space.md, marginTop:space.lg}}
                >
                  Add Food
                </Button>
              )}
            </>
          )}
        </>
      )}

      {/* ── Tab 1: Food Search (USDA) ── */}
      {tab === 1 && <OpenFoodFactsSearch />}

      {/* ── Tab 2: Barcode Scanner ── */}
      {tab === 2 && (
        <Card>
          {/* Scanner — hidden once a result is pending */}
          {!scannedFood && (
            <>
              <Text 
                style={{
                  fontWeight:"regular", 
                  fontSize:"16px",
                  lineHeight:"1",
                  textAlign: "center",
                  marginBottom:space.lg
                }}
              >
                Point your camera at a product barcode.
              </Text>
              <BarcodeScanner
                onResult={handleScanResult}
                onDuplicate={(food) => setDupeFood(food)} // show "already saved" UI, disable sav
                onClose={() => setTab(0)}
              />
            </>
          )}

          {/* Confirmation card — replaces scanner after scan */}
          {scannedFood && (
            dupeFood ? (
              <Alert severity="info">
                {dupeFood.name} is already in your food list.
                <Button disabled style={{marginBottom:space.md, marginTop:space.lg}}>Save</Button>
              </Alert>
            ) : (
              <ScanResultCard
                food={scannedFood}
                onConfirm={handleConfirm}
                onDiscard={handleDiscard}
              />
            )
          )}
        </Card>
      )}

      <FoodFormModal
        open={modalOpen}
        food={modalFood}
        onClose={() => setModalOpen(false)}
      />

      {/* Success toast */}
      {toast && (<Alert style={{marginTop: space.lg}}>{toast}</Alert>)}
      </Content>
    </Screen>
        
  );
}
